export default "__VITE_ASSET__CltVJI3Z__"